// extracted by mini-css-extract-plugin
export default {"forest-green":"#013a4c"};